import {apiResponseTypeEnum} from './api'

export const storeErrorMessagesPerResponseType = {
  [apiResponseTypeEnum.MSISDN_INVALID]: 'home_modals_invite_friend_error_msisdn_invalid',
  [apiResponseTypeEnum.MSISDN_NOT_EXIST]: 'home_modals_invite_friend_error_msisdn_not_exist'
}



// WEBPACK FOOTER //
// ./src/constants/store.js